import React from "react";

import "./charts-kit.css";

export type T_IntervalPillsProps<T_Interval extends string> = {
  active: T_Interval;
  intervals: readonly T_Interval[];
  onChange: (interval: T_Interval) => void;
};

/**
 * Shared time-range pill selector rendered below every price/value chart —
 * web mirror of the mobile IntervalPills. One visual treatment; the interval
 * set comes from the caller (UI convergence rule: never fork per surface).
 */
export function IntervalPills<T_Interval extends string>({
  active,
  intervals,
  onChange,
}: T_IntervalPillsProps<T_Interval>) {
  return (
    <div className="ck-pills" role="tablist" aria-label="Time range">
      {intervals.map((interval) => {
        const selected = active === interval;
        return (
          <button
            aria-selected={selected}
            className={selected ? "ck-pill ck-pill--selected" : "ck-pill"}
            key={interval}
            onClick={() => onChange(interval)}
            role="tab"
            type="button"
          >
            {interval}
          </button>
        );
      })}
    </div>
  );
}
